import { render, staticRenderFns } from "./ViewClaim.vue?vue&type=template&id=72e18f3b"
import script from "./ViewClaim.vue?vue&type=script&lang=js"
export * from "./ViewClaim.vue?vue&type=script&lang=js"
import style0 from "./ViewClaim.vue?vue&type=style&index=0&id=72e18f3b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports